import { REVIEW_REFERENCE, tokenizeRoute } from 'query/routes';
import { getCsrfToken } from 'util/authenticityToken';

type ReviewReferenceParams = { document_url: string };
type Strumber = string | number;

export type UpdateReviewReference = typeof updateReviewReference;
type UpdateReviewReferenceArgs = {
  reviewId: Strumber;
  studyId: Strumber;
  reviewReferenceId: Strumber;
  params: ReviewReferenceParams;
};

export type OnReviewReferenceUpdated = (
  reviewReferenceId: number,
  documentUrl: string
) => void;

export const updateReviewReference = async (
  args: UpdateReviewReferenceArgs
): Promise<any> => {
  const { reviewId, studyId, reviewReferenceId, params } = args;

  const url = tokenizeRoute(REVIEW_REFERENCE, {
    reviewId,
    studyId,
    reviewReferenceId,
  });

  const response = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    method: 'PUT',
  });

  if (response.ok) {
    return response.json();
  }

  try {
    const data = await response.json();
    return Promise.reject(data.error);
  } catch {
    return Promise.reject();
  }
};
